<template>
    <div class="d-flex flex-column gap-2 gap-lg-1">
        <label :for="inputId">
            {{ label }}
        </label>
        <div>
            <textarea
                v-if="isTextarea"
                :id="inputId"
                :name="inputKey"
                class="form-control border-3 border-top-0 border-start-0 border-end-0 border-bottom border-dark-focus rounded-0 bg-soft-secondary shadow-none prevent-autofill-background filled-input-border"
                placeholder=" "
                :rows="7"
                @input="(e) => updateInput(e.currentTarget.value)"
            />
            <template v-else-if="isCustomInput">
                <slot />
            </template>
            <input 
                v-else
                :id="inputId"
                :name="inputKey"
                class="form-control border-3 border-top-0 border-start-0 border-end-0 border-bottom border-dark-focus rounded-0 bg-soft-secondary shadow-none prevent-autofill-background filled-input-border"
                :type="type"
                placeholder=" "
                @input="(e) => updateInput(e.currentTarget.value)"
            >
        </div>
        <div v-show="error && errorMessage" class="text-danger bg-soft-danger small bg-gradient order-3 p-1 px-2">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        inputId: {
            type: String,
            required: true
        },
        isTextarea: {
            type: Boolean,
            required: false,
            default: false
        },
        isCustomInput: {
            type: Boolean,
            required: false,
            default: false
        },
        inputKey: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: false,
            default: 'text'
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        },
        errorMessage: {
            type: String,
            required: false,
            default: ''
        },
    },
    methods: {
        updateInput(value) {
            this.$emit('on-user-input', value, this.inputKey);
        }
    }
};
</script>